import axios from 'axios';
import { loadingActions } from '../redux/actions';
import { Store } from '../redux/stores';

export const filteredTemplates = async (filter) => {
    Store.dispatch(loadingActions.loadingStart('templates.filteredTemplates'));
    const defaultResponse = {status:'error', payload: []};
    try {
        let resp = await axios.get(`${process.env.REACT_APP_HOST}/sheettemplates${filter ? ('?search='+encodeURIComponent(filter)) : ''}`);
        Store.dispatch(loadingActions.loadingEnd('templates.filteredTemplates'));
        return resp && resp.data && resp.data.payload ? resp.data.payload : defaultResponse;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('templates.filteredTemplates'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultResponse;
    }
};

export const templateData = async (id, short) => {
    Store.dispatch(loadingActions.loadingStart('templates.templateData'));
    const defaultResponse = {status:'error', payload: []};
    try {
        let resp = await axios.get(`${process.env.REACT_APP_HOST}/sheettemplates/${id}`, {params:short ? {short: true} : null});
        Store.dispatch(loadingActions.loadingEnd('templates.templateData'));
        return resp && resp.data && resp.data.payload ? resp.data.payload : [];
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('templates.templateData'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultResponse;
    }
};

export const myTemplates = async () => {
    Store.dispatch(loadingActions.loadingStart('templates.myTemplates'));
    const defaultResponse = {status:'error', payload: []};
    try {
        let resp = await axios.get(`${process.env.REACT_APP_HOST}/sheettemplates/mytemplates`);
        Store.dispatch(loadingActions.loadingEnd('templates.myTemplates'));
        return resp && resp.data && resp.data.payload ? resp.data.payload : [];
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('templates.myTemplates'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultResponse;
    }
};

export const addEditorTotemplate = async (id, email) => {
    Store.dispatch(loadingActions.loadingStart('templates.addEditorTotemplate'));
    const defaultResponse = {status:'error', payload: {editableTo:[]}};
    try {
        let resp = await axios.post(`${process.env.REACT_APP_HOST}/sheettemplates/${id}/editable`, {editableTo: email});
        Store.dispatch(loadingActions.loadingEnd('templates.addEditorTotemplate'));
        return resp && resp.data && resp.data.payload ? resp.data.payload : {editableTo:[]};
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('templates.addEditorTotemplate'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultResponse;
    }
};

export const removeEditorFromTemplate = async (id, userId) => {
    Store.dispatch(loadingActions.loadingStart('templates.removeEditorFromTemplate'));
    const defaultResponse = {status:'error', payload: {editableTo:[]}};
    try {
        let resp = await axios.delete(`${process.env.REACT_APP_HOST}/sheettemplates/${id}/editable`, {data: {editableTo: userId}});
        Store.dispatch(loadingActions.loadingEnd('templates.removeEditorFromTemplate'));
        return resp && resp.data && resp.data.payload ? resp.data.payload : {editableTo:[]};
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('templates.removeEditorFromTemplate'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultResponse;
    }
};

export const createTemplates = async (template) => {
    Store.dispatch(loadingActions.loadingStart('templates.createTemplates'));
    const defaultResponse = {status:'error', payload: []};
    try {
        let resp = await axios.post(`${process.env.REACT_APP_HOST}/sheettemplates/new`, {
            name: template.name,
            isPublic: template.isPublic,
            content: template.content,
            system: template.system
        });
        Store.dispatch(loadingActions.loadingEnd('templates.createTemplates'));
        return resp && resp.data && resp.data.payload ? resp.data.payload : defaultResponse;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('templates.createTemplates'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultResponse;
    }
};

export const updateTemplates = async (id, template) => {
    Store.dispatch(loadingActions.loadingStart('templates.updateTemplates'));
    const defaultResponse = {status:'error', payload: []};
    try {
        let resp = await axios.put(`${process.env.REACT_APP_HOST}/sheettemplates/edit/${id}`, {
            name: template.name,
            isPublic: template.isPublic,
            content: template.content,
            system: template.system
        });
        Store.dispatch(loadingActions.loadingEnd('templates.updateTemplates'));
        return resp && resp.data && resp.data.payload ? resp.data.payload : defaultResponse;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('templates.updateTemplates'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultResponse;
    }
};

export const deleteTemplates = async (id, template) => {
    Store.dispatch(loadingActions.loadingStart('templates.deleteTemplates'));
    const defaultResponse = {status:'error', payload: []};
    try {
        let resp = await axios.delete(`${process.env.REACT_APP_HOST}/sheettemplates/delete/${id}`);
        Store.dispatch(loadingActions.loadingEnd('templates.deleteTemplates'));
        return resp && resp.data && resp.data.payload ? resp.data.payload : defaultResponse;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('templates.deleteTemplates'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultResponse;
    }
};

export const forkemplates = async (id) => {
    Store.dispatch(loadingActions.loadingStart('templates.forkemplates'));
    const defaultResponse = {status:'error', payload: []};
    try {
        let resp = await axios.post(`${process.env.REACT_APP_HOST}/sheettemplates/fork/${id}`);
        Store.dispatch(loadingActions.loadingEnd('templates.forkemplates'));
        return resp && resp.data && resp.data.payload ? resp.data.payload : defaultResponse;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('templates.forkemplates'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultResponse;
    }
};
